import { SUPER_ONLY, ADMINS } from "../../config/roleConfig";

export function isSuperAdmin(role, subrole) {
  try {
    return ADMINS.includes(role) && SUPER_ONLY.includes(subrole);
  } catch (e) {
    return false;
  }
}
